import {
  Row,
  Button,
  Label,
  Input,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import React, { Fragment } from "react";
import "../estilos.css";
import Pagination from "react-js-pagination";
import * as IoIcons from "react-icons/io";
import TimeField from "react-simple-timefield";
import useReciba from "../../hooks/useReciba";
import Moment from "moment";
import EtiquetaRAC from "../reciba/EtiquetaRAC";
import BarcodeReader from "react-barcode-reader";

function Incoming() {
  const {
    pincoming,
    pdescargarincoming,
    formType,
    color,
    aVisible,
    mensajeAlert,
    cargando,
    mRecibas,
    inputList,
    formData,
    isDisabled,
    modal3,
    locaciones,
    searchBy,
    estadoReciba,
    search,
    reciba,
    rfechaini,
    rfechafin,
    currentPage,
    recordPerPage,
    totalRecords,
    pageRange,
    registrosPorPagina,
    mEstatusUbicacion,
    mDatosInspeccion,
    componentRefTEV,
    recibaSerialesSinFiltro,
    nombreUsuario,
    handleError,
    handleScanI,
    imprimirInspeccion,
    setMEstatusUbicacion,
    setMDatosInspeccion,
    onDismiss,
    preciba,
    setInputList,
    toggle3,
    cancelarRecibaIncoming,
    setInputUbicaciones,
    onChangesUbicacion,
    handleInputChangeLocacion,
    handleInputChangeEspacio,
    onChangesFechaUbicacion,
    guardarIncomming,
    buscarpor,
    onestadoReciba,
    setSearch,
    onSearchFecha,
    handlePageChange,
    onSearch,
    onChangesRFecha,
    fetchReciba,
    cliclMostrar,
    cliclIncoming,
    clicDescargarDatos,
  } = useReciba();

  return (
    <>
      {pincoming === true && (
        <>
          <div className="conteiner3">
            <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
              {mensajeAlert}
            </Alert>

            {cargando === true && (
              <Row>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                  <img
                    width="150px"
                    alt="cargando"
                    src="assets/img/preloader.gif"
                  />
                </div>
              </Row>
            )}

            {formType === "Reciba" && (
              <Fragment>
                <BarcodeReader
                  onError={handleError}
                  onScan={handleScanI}
                  minLength={1}
                />
                <Row className="margintop10px">
                  <div class="col-lg-6 col-md-9 col-sm-12 col-xs-12 text-left  ">
                    <InputGroup></InputGroup>
                    <Label>
                      <h5>Busqueda por: </h5>
                    </Label>
                    <select
                      name="recibabusqueda"
                      className="ml-2"
                      onChange={buscarpor}>
                      <option
                        value="cliente"
                        selected={searchBy === "cliente" ? true : false}>
                        Cliente
                      </option>
                      <option
                        value="paking"
                        selected={searchBy === "paking" ? true : false}>
                        Packing
                      </option>
                      <option
                        value="numero de parte"
                        selected={
                          searchBy === "numero de parte" ? true : false
                        }>
                        Número de parte
                      </option>
                      <option
                        value="lote"
                        selected={searchBy === "lote" ? true : false}>
                        Lote
                      </option>
                      <option
                        value="fecha"
                        selected={searchBy === "fecha" ? true : false}>
                        Fecha
                      </option>
                      <option
                        value="serial"
                        selected={searchBy === "serial" ? true : false}>
                        Serial
                      </option>
                      <option
                        value="id de reciba"
                        selected={searchBy === "id de reciba" ? true : false}>
                        ID de Reciba
                      </option>
                    </select>
                    <select
                      name="recibaestado"
                      className="estadoproductoscombo"
                      onChange={onestadoReciba}>
                      <option
                        value="todos"
                        selected={estadoReciba === "todos" ? true : false}>
                        Todo el material
                      </option>
                      <option
                        value="En reciba"
                        selected={estadoReciba === "En reciba" ? true : false}>
                        Material en Reciba
                      </option>
                      <option
                        value="Rechazado"
                        selected={estadoReciba === "Rechazado" ? true : false}>
                        Material rechazado
                      </option>
                      <option
                        value="Aceptado"
                        selected={estadoReciba === "Aceptado" ? true : false}>
                        Material aceptado
                      </option>
                      <option
                        value="Parcialmente Rechazado"
                        selected={
                          estadoReciba === "Parcialmente Rechazado"
                            ? true
                            : false
                        }>
                        Material Parcialmente Rechazado
                      </option>
                    </select>
                    {/*searchBy!=="fecha" &&()*/}
                    <Input
                      className="marginlbusqueda"
                      type={searchBy !== "fecha" ? "text" : "date"}
                      placeholder={"Búsqueda por " + searchBy}
                      onChange={
                        searchBy !== "fecha"
                          ? (e) => setSearch(e.target.value)
                          : onSearchFecha
                      }
                      onKeyUp={searchBy !== "fecha" ? onSearch : ""}
                      value={search}
                    />
                  </div>
                  <div className=" form-group row col-lg-3 col-md-12 col-sm-12 col-xs-12">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>Del:</InputGroupText>
                      </InputGroupAddon>
                      <Input
                        name="rfechaini"
                        type="date"
                        value={Moment(rfechaini).format("YYYY-MM-DD")}
                        onChange={onChangesRFecha}
                      />
                    </InputGroup>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>Al:</InputGroupText>
                      </InputGroupAddon>
                      <Input
                        name="rfechafin"
                        type="date"
                        value={Moment(rfechafin).format("YYYY-MM-DD")}
                        onChange={onChangesRFecha}
                      />
                    </InputGroup>
                  </div>
                </Row>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left ">
                  {/*<button
                    className="cbutton btn-success floatright ml-2 "
                    title="Incoming"
                    onClick={() => {
                      handleScanI("F002");
                    }}>
                    <IoIcons.IoIosAlbums /> Incoming
                  </button>*/}
                  <button
                    className="cbutton btn-dark floatright ml-2 "
                    title="Recargar página"
                    onClick={() => {
                      fetchReciba();
                    }}>
                    <IoIcons.IoMdRefresh /> Recargar
                  </button>
                  {pdescargarincoming && (
                    <button
                      class="btn-warning cbutton floatrightleft "
                      title="Exportar los datos a excel"
                      onClick={() => clicDescargarDatos("descargaIncoming")}>
                      <IoIcons.IoIosDownload /> Descargar datos
                    </button>
                  )}
                </div>
                <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll wrapper">
                  <Table className=" mb-2  ">
                    <Thead class="thead-secondary">
                      <Tr>
                        <Th>ID</Th>
                        <Th>Cliente</Th>
                        <Th className="minwidth80px">Fecha y hora de reciba</Th>
                        <Th>Status</Th>
                        <Th>Cantidad Recibida</Th>
                        <Th>Packing </Th>
                        <Th>Número de parte</Th>
                        <Th>Lote</Th>
                        <Th>Serial</Th>
                        <Th className="minwidth80px">
                          Acciones{" "}
                          {/*userName==="GELA"?"Incoming": "Acciones" */}{" "}
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {reciba.map((reciba, i) => (
                        <Tr class={i % 2 !== 0 ? "table-active" : ""}>
                          <Td>{reciba.numero}</Td>
                          <Td>{reciba.cliente}</Td>
                          <Td className="margintopmobil20px">
                            {Moment(reciba.fechaDeReciba).format("DD/MM/YYYY") +
                              " " +
                              reciba.horaDeReciba}
                          </Td>
                          <Td className="margintopmobil20px">
                            {reciba.status}
                          </Td>
                          <Td className="margintopmobil20px">
                            {reciba.cantidadRecibida}
                          </Td>
                          <Td className="margintopmobil20px">
                            {reciba.packings}
                          </Td>
                          <Td className="margintopmobil20px">
                            {reciba.numerosdeParte}
                          </Td>
                          <Td className="margintopmobil20px">{reciba.lotes}</Td>
                          <Td className="margintopmobil20px">
                            {reciba.seriales}
                          </Td>
                          <Td className="margintopmobil40px">
                            {
                              //userName !== "GELA" && (
                              <>
                                <button
                                  class="btn-info cbutton mt-1 ml-1"
                                  onClick={() => cliclMostrar(reciba)}
                                  title="Detalles de reciba">
                                  {" "}
                                  <IoIcons.IoIosListBox />{" "}
                                </button>
                                <button
                                  class="btn-success cbutton mt-1 ml-1"
                                  onClick={() => cliclIncoming(reciba)}
                                  title="Incoming">
                                  {" "}
                                  <IoIcons.IoIosAlbums />{" "}
                                </button>
                                {pdescargarincoming && (
                                  <button
                                    class="btn-warning cbutton mt-1 ml-1"
                                    title="Imprimir registro de inspección de recibo"
                                    onClick={() => imprimirInspeccion(reciba)}
                                  >
                                    <IoIcons.IoIosPrint />
                                  </button>
                                )}
                              </>
                              /*)*/
                            }
                            {/*userName==="GELA" &&(
                                            <>
                                            <button class="btn-success cbutton mt-1 ml-1"  onClick={()=>cliclIncoming(reciba)}  title="Incoming"> <IoIcons.IoIosCreate/> </button>                                                                                                                         
                                            </>
                                        )*/}
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </div>
                <div className="mt-3 mb-3">
                  Página {currentPage}, mostrando del{" "}
                  {recordPerPage * currentPage - recordPerPage + 1} al{" "}
                  {totalRecords < recordPerPage * currentPage
                    ? totalRecords
                    : recordPerPage * currentPage}{" "}
                  de {totalRecords} registros
                </div>
                <Row>
                  <div className="col-lg-12 col-md-12 col-sm-12  ">
                    <div className="floatcenter">
                      <Pagination
                        itemClass="page-item" // add it for bootstrap 4
                        linkClass="page-link" // add it for bootstrap 4
                        activePage={currentPage}
                        itemsCountPerPage={recordPerPage}
                        totalItemsCount={totalRecords}
                        pageRangeDisplayed={pageRange}
                        onChange={handlePageChange}
                      />
                    </div>
                  </div>
                </Row>
                <div style={{ display: "none" }}>
                  <div ref={componentRefTEV}>
                    <Row>
                      <img
                        className="imgmarlimpI"
                        src="assets/img/Logo/logost.png"
                      />
                      <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                        <Table
                          bordered
                          className="margintop20px fontsize18px "
                        >
                          <Thead>
                            <Tr>
                              <Th className="thtableImprimir    textaligmentcenter">
                                <Label className="fontsize30px mt-2 mb-2">REGISTRO DE INSPECCIÓN DE RECIBO </Label>
                              </Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                          </Tbody>
                        </Table>
                        <Table
                          bordered
                          className=" fontsize18px "
                        >
                          <Thead>
                            <Tr>
                              <Th className="thtableImprimir    textaligmentcenter">
                                Fecha
                              </Th>
                              <Th className="thtableImprimir    textaligmentcenter">
                                Operación #
                              </Th>
                              <Th className="thtableImprimir    textaligmentcenter">
                                Descripción operación
                              </Th>
                              <Th className="thtableImprimir    textaligmentcenter">
                                Frecuencia
                              </Th>
                              <Th className="thtableImprimir    textaligmentcenter">
                                Proveedor/Cliente:
                              </Th>
                              <Th className="thtableImprimir    textaligmentcenter">
                                Aprobación de calidad
                              </Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            <Tr>
                              <Td className="textaligmentcenter">
                                {inputList[0] ? inputList[0].fechaDeReciba : ""}
                              </Td>
                              <Td className="textaligmentcenter">
                                10
                              </Td>
                              <Td className="textaligmentcenter">
                                Inspección de reciba
                              </Td>
                              <Td className="textaligmentcenter">
                                Reciba
                              </Td>
                              <Td className="textaligmentcenter">
                                {inputList[0] ? inputList[0].cliente : ""}
                              </Td >
                              <Td className="textaligmentcenter">
                                {inputList[0] ? inputList[0].usuarioIncoming ? inputList[0].usuarioIncoming : nombreUsuario : nombreUsuario}
                              </Td>
                            </Tr>
                          </Tbody>
                        </Table>
                        <Table
                          bordered
                          className=" margintop20px fontsize18px "
                        >
                          <Thead>
                            <Tr>
                              <Th className="thtableImprimir  minwidth130px  textaligmentcenter">
                                Número de parte
                              </Th>
                              <Th className="thtableImprimir minwidth130px   textaligmentcenter">
                                Descripción
                              </Th>
                              <Th className="thtableImprimir    textaligmentcenter">
                                Packing/Line
                              </Th>
                              <Th className="thtableImprimir    textaligmentcenter">
                                Lote
                              </Th>
                              <Th className="thtableImprimir    textaligmentcenter">
                                Estatus
                              </Th>
                              <Th className="thtableImprimir    textaligmentcenter">
                                Serial
                              </Th>
                              <Th className="thtableImprimir    textaligmentcenter">
                                Cantidad
                              </Th>
                              <Th className="thtableImprimir    textaligmentcenter">
                                Empaque libre de daños
                              </Th>
                              <Th className="thtableImprimir    textaligmentcenter">
                                Material correcto/no mezclado
                              </Th>
                              <Th className="thtableImprimir    textaligmentcenter">
                                Material no contaminado con oxido, grasas, material extraño
                              </Th>
                              <Th className="thtableImprimir    textaligmentcenter">
                                Material sin defectos obvios (piezas dobladas o golpeadas)
                              </Th>
                              <Th className="thtableImprimir    textaligmentcenter">
                                Prueba de solubilidad
                              </Th>
                              <Th className="thtableImprimir    textaligmentcenter">
                                Espesor
                              </Th>
                              <Th className="thtableImprimir    textaligmentcenter">
                                Comentarios
                              </Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {inputList.map((reciba, i) => (
                              i < registrosPorPagina && (
                                <Tr>
                                  <Td className="textaligmentcenter">
                                    {reciba.numerodeParte}
                                  </Td>
                                  <Td className="textaligmentcenter">
                                    {reciba.descripcion}
                                  </Td>
                                  <Td className="textaligmentcenter">
                                    {reciba.packing}
                                  </Td>
                                  <Td className="textaligmentcenter">
                                    {reciba.lote}
                                  </Td>
                                  <Td className="textaligmentcenter">
                                    {reciba.status}
                                  </Td>
                                  <Td className="textaligmentcenter">
                                    {reciba.serial}
                                  </Td>
                                  <Td className="textaligmentcenter">
                                    {reciba.cantidadRecibida}
                                  </Td>
                                  <Td className="textaligmentcenter">
                                    {reciba.empaqueSinDanos}
                                  </Td>
                                  <Td className="textaligmentcenter">
                                    {reciba.materialCorrecto}
                                  </Td>
                                  <Td className="textaligmentcenter">
                                    {reciba.materialNContaminado}
                                  </Td>
                                  <Td className="textaligmentcenter">
                                    {reciba.materialSinDefectosOvios}
                                  </Td>
                                  <Td className="textaligmentcenter">
                                    {reciba.pruebaSolubilidad}
                                  </Td>
                                  <Td className="textaligmentcenter">
                                    {reciba.espesor}
                                  </Td>
                                  <Td className="textaligmentcenter">
                                    {reciba.comentariosdeinspeccion}
                                  </Td>
                                </Tr>
                              )))}
                          </Tbody>
                        </Table>
                        {(inputList.length > registrosPorPagina) && (
                          <div className="page-break" >
                            <Table
                              bordered
                              className=" margintop20px fontsize18px "
                            >
                              <Thead>
                                <Tr>
                                  <Th className="thtableImprimir minwidth130px   textaligmentcenter">
                                    Número de parte
                                  </Th>
                                  <Th className="thtableImprimir  minwidth130px  textaligmentcenter">
                                    Descripción
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Packing/Line
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Lote
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Estatus
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Serial
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Cantidad
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Empaque libre de daños
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Material correcto/no mezclado
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Material no contaminado con oxido, grasas, material extraño
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Material sin defectos obvios (piezas dobladas o golpeadas)
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Prueba de solubilidad
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Espesor
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Comentarios
                                  </Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                {inputList.map((reciba, i) => (
                                  (i >= registrosPorPagina && i < (registrosPorPagina * 2)) && (
                                    <Tr>
                                      <Td className="textaligmentcenter">
                                        {reciba.numerodeParte}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.descripcion}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.packing}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.lote}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.status}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.serial}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.cantidadRecibida}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.empaqueSinDanos}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.materialCorrecto}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.materialNContaminado}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.materialSinDefectosOvios}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.pruebaSolubilidad}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.espesor}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.comentariosdeinspeccion}
                                      </Td>
                                    </Tr>
                                  )))}
                              </Tbody>
                            </Table>
                          </div>

                        )}
                        {(inputList.length > registrosPorPagina * 2) && (
                          <div className="page-break" >
                            <Table
                              bordered
                              className=" margintop20px fontsize18px "
                            >
                              <Thead>
                                <Tr>
                                  <Th className="thtableImprimir minwidth130px   textaligmentcenter">
                                    Número de parte
                                  </Th>
                                  <Th className="thtableImprimir  minwidth130px  textaligmentcenter">
                                    Descripción
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Packing/Line
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Lote
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Estatus
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Serial
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Cantidad
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Empaque libre de daños
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Material correcto/no mezclado
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Material no contaminado con oxido, grasas, material extraño
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Material sin defectos obvios (piezas dobladas o golpeadas)
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Prueba de solubilidad
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Espesor
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Comentarios
                                  </Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                {inputList.map((reciba, i) => (
                                  (i >= registrosPorPagina * 2 && i < (registrosPorPagina * 3)) && (
                                    <Tr>
                                      <Td className="textaligmentcenter">
                                        {reciba.numerodeParte}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.descripcion}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.packing}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.lote}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.status}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.serial}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.cantidadRecibida}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.empaqueSinDanos}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.materialCorrecto}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.materialNContaminado}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.materialSinDefectosOvios}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.pruebaSolubilidad}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.espesor}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.comentariosdeinspeccion}
                                      </Td>
                                    </Tr>
                                  )))}
                              </Tbody>
                            </Table>
                          </div>

                        )}
                        {(inputList.length > registrosPorPagina * 3) && (
                          <div className="page-break" >
                            <Table
                              bordered
                              className=" margintop20px fontsize18px "
                            >
                              <Thead>
                                <Tr>
                                  <Th className="thtableImprimir minwidth130px   textaligmentcenter">
                                    Número de parte
                                  </Th>
                                  <Th className="thtableImprimir  minwidth130px  textaligmentcenter">
                                    Descripción
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Packing/Line
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Lote
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Estatus
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Serial
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Cantidad
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Empaque libre de daños
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Material correcto/no mezclado
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Material no contaminado con oxido, grasas, material extraño
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Material sin defectos obvios (piezas dobladas o golpeadas)
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Prueba de solubilidad
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Espesor
                                  </Th>
                                  <Th className="thtableImprimir    textaligmentcenter">
                                    Comentarios
                                  </Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                {inputList.map((reciba, i) => (
                                  (i >= registrosPorPagina * 3) && (
                                    <Tr>
                                      <Td className="textaligmentcenter">
                                        {reciba.numerodeParte}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.descripcion}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.packing}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.lote}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.status}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.serial}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.cantidadRecibida}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.empaqueSinDanos}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.materialCorrecto}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.materialNContaminado}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.materialSinDefectosOvios}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.pruebaSolubilidad}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.espesor}
                                      </Td>
                                      <Td className="textaligmentcenter">
                                        {reciba.comentariosdeinspeccion}
                                      </Td>
                                    </Tr>
                                  )))}
                              </Tbody>
                            </Table>
                          </div>

                        )}
                      </div>
                    </Row>
                    <div class="tfooter">
                      <p className="floatleft ">
                        Escribir "Ok" si el resultado es aceptable y "NOK" en caso contrario para inspección de atributos. En caso de lecturas de lectura de medición, anotar el resultado del equipo.
                        Si el resultado no es aceptable, 1) Detener el Producto segun procedimiento de Producto no Conforme; 2) Notificar al contacto de calidad del cliente y/o compras; 3) Espere disposición.
                        Si ya tiene la disposición, proceda según corresponda.
                        El inspector debe documentar el evento y disposición en la sección de comentarios, incluyendo la información de quien da la disposición y a donde se canalizó el material.
                        En caso de defectos de proveedor, el Gerente de Calidad determinará si una acción correctiva formal es necesaria para atender el evento e iniciar el proceso correspondiente.
                      </p>
                      <p className="floatright  fontblackbold">
                        RIR-01 REV B
                      </p>
                    </div>
                  </div>
                </div>
                {/*<div style={{ marginTop: 20 }}>{JSON.stringify(recibaSerialesSinFiltro)}</div>*/}
                <Modal isOpen={modal3} toggle={toggle3}>
                  <ModalHeader toggle={toggle3}>Incoming</ModalHeader>
                  <ModalBody>
                    {inputList.map((x, i) => {
                      return (
                        <>
                          <Row>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Label className="tbold">Cliente: </Label><Label> {x.cliente} </Label>
                            </div>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Label className="tbold">Fecha y hora de reciba: </Label><Label> {x.fechayHoraDeReciba} </Label>
                            </div>
                          </Row>
                          <Row>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Label className="tbold">Packing: </Label> <Label>{x.packing} </Label>
                            </div>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Label className="tbold">No. de parte: </Label> <Label>{x.numerodeParte}</Label>
                            </div>
                          </Row>
                          <Row>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Label className="tbold">Descripción: </Label><Label> {x.descripcion} </Label>
                            </div>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Label className="tbold">Serial: </Label> <Label>{x.serial}</Label>
                            </div>
                          </Row>
                          <Row>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Label className="tbold">Serial BTI: </Label><Label> {x.serialRecibaBTI} </Label>
                            </div>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Label className="tbold">Cantidad: </Label>
                              <Label> {x.cantidadRecibida} </Label>
                            </div>
                          </Row>
                          <Row>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Label className="tbold">Estatus*</Label>
                            </div>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <select
                                name="status"
                                className=" custom-select"
                                onChange={(e) =>
                                  setInputUbicaciones(
                                    onChangesUbicacion(e, i, [
                                      ...inputList,
                                    ])
                                  )
                                }
                                disabled={!x.cantidadPlaneada ? false : x.cantidadPlaneada > 0 ? true : false}>
                                <option
                                  value="En reciba"
                                  selected={
                                    x.status === "En reciba"
                                      ? true
                                      : false
                                  }>
                                  {"En reciba"}
                                </option>
                                <option
                                  value="Aceptado"
                                  selected={
                                    x.status === "Aceptado" ? true : false
                                  }>
                                  Aceptado
                                </option>
                                <option
                                  value="Rechazado"
                                  selected={
                                    x.status === "Rechazado"
                                      ? true
                                      : false
                                  }>
                                  Rechazado
                                </option>
                              </select>{" "}
                            </div>
                          </Row>
                          <Row>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Label className="tbold">Ubicación*</Label>
                            </div>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <select
                                name="ubicacion"
                                className=" custom-select"
                                onChange={(e) =>
                                  setInputUbicaciones(
                                    onChangesUbicacion(e, i, [
                                      ...inputList,
                                    ])
                                  )
                                }
                                disabled={!x.cantidadPlaneada ? false : x.cantidadPlaneada > 0 ? true : false}>
                                {x.status === "Aceptado" && (
                                  <>
                                    <option
                                      value="Almacén"
                                      selected={
                                        x.ubicacion === "Almacén"
                                          ? true
                                          : false
                                      }>
                                      Almacén
                                    </option>
                                    <option
                                      value="Producción"
                                      selected={
                                        x.ubicacion === "Producción"
                                          ? true
                                          : false
                                      }>
                                      Producción
                                    </option>
                                    <option
                                      value="Proveedor externo"
                                      selected={
                                        x.ubicacion ===
                                          "Proveedor externo"
                                          ? true
                                          : false
                                      }>
                                      Proveedor externo
                                    </option>
                                  </>
                                )}
                                {x.status === "En reciba" && (
                                  <>
                                    <option
                                      value="Reciba"
                                      selected={
                                        x.ubicacion === "Reciba"
                                          ? true
                                          : false
                                      }>
                                      Reciba
                                    </option>
                                  </>
                                )}
                                {x.status === "Rechazado" && (
                                  <>
                                    <option
                                      value="Cuarentena"
                                      selected={
                                        x.ubicacion === "Cuarentena"
                                          ? true
                                          : false
                                      }>
                                      Cuarentena
                                    </option>
                                  </>
                                )}
                              </select>
                            </div>
                          </Row>
                          <Row>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Label className="tbold">Fecha de ubicación*</Label>
                            </div>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Input
                                name="fechaDeUbicacion"
                                type="date"
                                value={x.fechaDeUbicacion}
                                disabled={!x.cantidadPlaneada ? false : x.cantidadPlaneada > 0 ? true : false}
                                onChange={(e) =>
                                  setInputUbicaciones(
                                    onChangesFechaUbicacion(e, i, [
                                      ...inputList,
                                    ])
                                  )
                                }
                              />
                            </div>
                          </Row>
                          <Row>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Label className="tbold">Hora de ubicación*</Label>
                            </div>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <TimeField
                                name="horaDeUbicacion"
                                className="w-100 custom-time"
                                disabled={!x.cantidadPlaneada ? false : x.cantidadPlaneada > 0 ? true : false}
                                value={x.horaDeUbicacion}
                                onChange={(e) =>
                                  setInputUbicaciones(
                                    onChangesUbicacion(e, i, [
                                      ...inputList,
                                    ])
                                  )
                                }
                              />
                            </div>
                          </Row>
                          <Row>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Label className="tbold">Quién Inspeccionó</Label>
                            </div>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Input
                                name="quienInspecciono"
                                type="text"
                                value={x.quienInspecciono}
                                disabled={!x.cantidadPlaneada ? false : x.cantidadPlaneada > 0 ? true : false}
                                onChange={(e) =>
                                  setInputUbicaciones(
                                    onChangesUbicacion(e, i, [
                                      ...inputList,
                                    ])
                                  )
                                }
                              />
                            </div>
                          </Row>
                          <Row>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Label className="tbold">Defecto</Label>
                            </div>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Input
                                name="defectoCuarentena"
                                type="textarea"
                                disabled={!x.cantidadPlaneada ? false : x.cantidadPlaneada > 0 ? true : false}
                                rows="1"
                                value={x.defectoCuarentena}
                                onChange={(e) =>
                                  setInputUbicaciones(
                                    onChangesUbicacion(e, i, [
                                      ...inputList,
                                    ])
                                  )
                                }
                              />
                            </div>
                          </Row>
                          <Row>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Label className="tbold">Comentarios</Label>
                            </div>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Input
                                name="comentariosdeinspeccion"
                                type="textarea"
                                disabled={!x.cantidadPlaneada ? false : x.cantidadPlaneada > 0 ? true : false}
                                rows="1"
                                value={x.comentariosdeinspeccion}
                                onChange={(e) =>
                                  setInputUbicaciones(
                                    onChangesUbicacion(e, i, [
                                      ...inputList,
                                    ])
                                  )
                                }
                              />
                            </div>
                          </Row>
                          <Row>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Label className="tbold">Empaque libre de daño</Label>
                            </div>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <select
                                name="empaqueSinDanos"
                                className=" custom-select"
                                onChange={(e) =>
                                  setInputUbicaciones(
                                    onChangesUbicacion(e, i, [
                                      ...inputList,
                                    ])
                                  )
                                }
                              >
                                <option
                                  value=""
                                  selected={
                                    x.empaqueSinDanos === ""
                                      ? true
                                      : false
                                  }>
                                  ---
                                </option>
                                <option
                                  value="OK"
                                  selected={
                                    x.empaqueSinDanos === "OK"
                                      ? true
                                      : false
                                  }>
                                  OK
                                </option>
                                <option
                                  value="NOK"
                                  selected={
                                    x.empaqueSinDanos === "NOK"
                                      ? true
                                      : false
                                  }>
                                  NOK
                                </option>
                                <option
                                  value="N/A"
                                  selected={
                                    x.empaqueSinDanos ===
                                      "N/A"
                                      ? true
                                      : false
                                  }>
                                  N/A
                                </option>
                              </select>
                            </div>
                          </Row>
                          <Row>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Label className="tbold">Material correcto/ no mezclado</Label>
                            </div>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <select
                                name="materialCorrecto"
                                className=" custom-select"
                                onChange={(e) =>
                                  setInputUbicaciones(
                                    onChangesUbicacion(e, i, [
                                      ...inputList,
                                    ])
                                  )
                                }
                              >
                                <option
                                  value=""
                                  selected={
                                    x.materialCorrecto === ""
                                      ? true
                                      : false
                                  }>
                                  ---
                                </option>
                                <option
                                  value="OK"
                                  selected={
                                    x.materialCorrecto === "OK"
                                      ? true
                                      : false
                                  }>
                                  OK
                                </option>
                                <option
                                  value="NOK"
                                  selected={
                                    x.materialCorrecto === "NOK"
                                      ? true
                                      : false
                                  }>
                                  NOK
                                </option>
                                <option
                                  value="N/A"
                                  selected={
                                    x.materialCorrecto ===
                                      "N/A"
                                      ? true
                                      : false
                                  }>
                                  N/A
                                </option>
                              </select>
                            </div>
                          </Row>
                          <Row>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Label className="tbold">Material no contaminado con oxido, grasas, material extraño</Label>
                            </div>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <select
                                name="materialNContaminado"
                                className=" custom-select"
                                onChange={(e) =>
                                  setInputUbicaciones(
                                    onChangesUbicacion(e, i, [
                                      ...inputList,
                                    ])
                                  )
                                }
                              >
                                <option
                                  value=""
                                  selected={
                                    x.materialNContaminado === ""
                                      ? true
                                      : false
                                  }>
                                  ---
                                </option>
                                <option
                                  value="OK"
                                  selected={
                                    x.materialNContaminado === "OK"
                                      ? true
                                      : false
                                  }>
                                  OK
                                </option>
                                <option
                                  value="NOK"
                                  selected={
                                    x.materialNContaminado === "NOK"
                                      ? true
                                      : false
                                  }>
                                  NOK
                                </option>
                                <option
                                  value="N/A"
                                  selected={
                                    x.materialNContaminado ===
                                      "N/A"
                                      ? true
                                      : false
                                  }>
                                  N/A
                                </option>
                              </select>
                            </div>
                          </Row>
                          <Row>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Label className="tbold">Material sin defectos obvios (piezas dobladas o golpeadas)</Label>
                            </div>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <select
                                name="materialSinDefectosOvios"
                                className=" custom-select"
                                onChange={(e) =>
                                  setInputUbicaciones(
                                    onChangesUbicacion(e, i, [
                                      ...inputList,
                                    ])
                                  )
                                }
                              >
                                <option
                                  value=""
                                  selected={
                                    x.materialSinDefectosOvios === ""
                                      ? true
                                      : false
                                  }>
                                  ---
                                </option>
                                <option
                                  value="OK"
                                  selected={
                                    x.materialSinDefectosOvios === "OK"
                                      ? true
                                      : false
                                  }>
                                  OK
                                </option>
                                <option
                                  value="NOK"
                                  selected={
                                    x.materialSinDefectosOvios === "NOK"
                                      ? true
                                      : false
                                  }>
                                  NOK
                                </option>
                                <option
                                  value="N/A"
                                  selected={
                                    x.materialSinDefectosOvios ===
                                      "N/A"
                                      ? true
                                      : false
                                  }>
                                  N/A
                                </option>
                              </select>
                            </div>
                          </Row>
                          <Row>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Label className="tbold">Prueba de solubilidad</Label>
                            </div>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <select
                                name="pruebaSolubilidad"
                                className=" custom-select"
                                onChange={(e) =>
                                  setInputUbicaciones(
                                    onChangesUbicacion(e, i, [
                                      ...inputList,
                                    ])
                                  )
                                }
                              >
                                <option
                                  value=""
                                  selected={
                                    x.pruebaSolubilidad === ""
                                      ? true
                                      : false
                                  }>
                                  ---
                                </option>
                                <option
                                  value="OK"
                                  selected={
                                    x.pruebaSolubilidad === "OK"
                                      ? true
                                      : false
                                  }>
                                  OK
                                </option>
                                <option
                                  value="NOK"
                                  selected={
                                    x.pruebaSolubilidad === "NOK"
                                      ? true
                                      : false
                                  }>
                                  NOK
                                </option>
                                <option
                                  value="N/A"
                                  selected={
                                    x.pruebaSolubilidad ===
                                      "N/A"
                                      ? true
                                      : false
                                  }>
                                  N/A
                                </option>
                              </select>
                            </div>
                          </Row>
                          <Row>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Label className="tbold">Espesor</Label>
                            </div>
                            <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                              <Input
                                name="espesor"
                                type="text"
                                rows="1"
                                value={x.espesor}
                                onChange={(e) =>
                                  setInputUbicaciones(
                                    onChangesUbicacion(e, i, [
                                      ...inputList,
                                    ])
                                  )
                                }
                              />
                            </div>
                          </Row>
                        </>);
                    })}
                    {/*JSON.stringify(recibaSerialesSinFiltro)*/}
                  </ModalBody>
                  <ModalFooter>
                    <Button color="primary" onClick={() => guardarIncomming(true)}>
                      Aceptar
                    </Button>{" "}
                    <Button color="secondary" onClick={toggle3}>
                      Cancelar
                    </Button>
                  </ModalFooter>
                </Modal>
              </Fragment>
            )}
          </div>
          <div className="conteiner2">
            {formType === "Detalle Reciba " + mRecibas.numero && (
              <Fragment>
                <Row>
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 floatleft">
                      {/*<button class=" btn-secondary cbutton floatleft " color="primary" onClick={() => clicEditar(mRecibas.id, mRecibas.clienteID, mRecibas.numero)} title="Editar">
                                            <IoIcons.IoIosCreate />Editar </button>*/}
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 floatright">
                      <button
                        class="btn-info cbutton floatright"
                        onClick={preciba}
                        title="Regresar">
                        <IoIcons.IoMdArrowRoundBack />
                        Regresar{" "}
                      </button>
                    </div>
                  </div>
                  <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px scroll">
                    <div className="textaligmentleft">
                      {" "}
                      <h5>Datos generales</h5>
                      {(mRecibas.cliente === "METALSTA" || mRecibas.cliente === "AMPHENOL ADRONICS") && (<h5 className="bcolordb">Identificar con Cono Verde</h5>)}
                    </div>
                    <Table className=" mb-2  ">
                      <Thead class="thead-secondary">
                        <Tr>
                          <Th>ID</Th>
                          <Th>Cliente</Th>
                          <Th className="minwidth80px">
                            Fecha y hora de reciba
                          </Th>
                          <Th>Cantidad por reciba</Th>
                          <Th>Status</Th>
                          <Th> Quien Inspeccionó </Th>
                          <Th> Comentarios de inspección </Th>
                          <Th> PO'S </Th>
                          <Th> Registros </Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        <Tr>
                          <Td>{mRecibas.numero}</Td>
                          <Td>{mRecibas.cliente}</Td>
                          <Td className="margintopmobil20px">
                            {Moment(mRecibas.fechaDeReciba).format(
                              "DD/MM/YYYY"
                            ) +
                              " " +
                              mRecibas.horaDeReciba}
                          </Td>
                          <Td className="margintopmobil20px">
                            {mRecibas.cantidadRecibida}
                          </Td>
                          <Td className="margintopmobil20px">
                            {mRecibas.status}
                          </Td>
                          <Td className="margintopmobil20px">
                            {mRecibas.quienInspecciono}
                          </Td>
                          <Td className="margintopmobil20px">
                            {mRecibas.comentarios}
                          </Td>
                          <Td className="margintopmobil50px">{mRecibas.po}</Td>
                          <Td className="margintopmobil50px">
                            {inputList.length ? inputList.length : 0}
                          </Td>
                        </Tr>
                      </Tbody>
                    </Table>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 textaligmentleft margintop20px">
                    <h5>Detalle</h5>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 margintop20px">
                    <EtiquetaRAC
                      indice={0}
                      inputList={inputList}
                      mRecibas={mRecibas}
                      tipo={"todo"}
                      bColor={"warning floatrightleft"}
                      btitle={"Etiqueta viajera"}
                      llamada={"Todo"}
                    />
                  </div>
                  <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll ">
                    <Table className=" mb-2">
                      <Thead class="thead-secondary">
                        <Tr>
                          <Th>
                            {" "}
                            {mRecibas.cliente === "Olson Internacional"
                              ? "Line"
                              : "Packing"}
                          </Th>
                          <Th>Número de parte</Th>
                          <Th>Descripción</Th>
                          <Th>Material en</Th>
                          <Th>Empaques</Th>
                          <Th>Peso Klg</Th>
                          <Th>Proceso</Th>
                          <Th>Lote</Th>
                          <Th>Serial</Th>
                          <Th className="minwidth80px">Serial BTI</Th>
                          <Th>Cantidad por serial</Th>
                          <Th>Estatus</Th>
                          <Th>Ubicación</Th>
                          <Th>Locación</Th>
                          <Th>Espacios</Th>
                          <Th>Fecha y hora de ubicación </Th>
                          <Th>Quién Inspeccionó</Th>
                          <Th>Defecto</Th>
                          <Th>Comentarios</Th>
                          <Th>Imprimir Etiqueta</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {inputList.map((x, i) => {
                          return (
                            x.activo && (
                              <Tr
                                class={
                                  !x.scolor
                                    ? i % 2 !== 0
                                      ? "table-active"
                                      : ""
                                    : x.scolor
                                }>
                                <Td className="margintopmobil20px">
                                  {x.packing}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.numerodeParte}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.descripcion}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.materialEn}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.materialEnCantidad}
                                </Td>
                                <Td className="margintopmobil20px">{x.peso}</Td>
                                <Td className="margintopmobil20px">
                                  <Label>{(x.Ecoat === true || (!x.Ecoat && x.precioUnitario)) ? "Ecoat" : ""}</Label>
                                  <Label className="mt-1">{x.Pcoat === true ? "Powder coat" : ""}</Label>
                                  {/*<Label className="mt-1">{x.Platinado === true ? "Platinado" : ""}</Label>*/}
                                </Td>
                                <Td className="margintopmobil20px">{x.lote}</Td>
                                <Td className="margintopmobil20px">
                                  {x.serial}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.serialRecibaBTI}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.cantidadRecibida}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.status}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.ubicacion}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {" "}
                                  {x.locacion}{" "}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {" "}
                                  {x.espacioOcupado}{" "}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {" "}
                                  {x.fechaDeUbicacion +
                                    " " +
                                    x.horaDeUbicacion}{" "}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {" "}
                                  {x.quienInspecciono}{" "}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {" "}
                                  {x.defectoCuarentena}{" "}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {" "}
                                  {x.comentariosdeinspeccion}{" "}
                                </Td>
                                <Td>
                                  {/*<EtiquetaRAC
                                    indice={i}
                                    inputList={inputList}
                                    mRecibas={mRecibas}
                                    tipo={"total"}
                                    bColor={"warning mt-1 ml-1"}
                                    btitle={"Etiqueta viajera - Reciba"}
                                    llamada={"Todo"}
                                  />
                                  <EtiquetaRAC
                                    indice={i}
                                    inputList={inputList}
                                    mRecibas={mRecibas}
                                    tipo={"parcial"}
                                    bColor={"dark mt-1 ml-1"}
                                    btitle={
                                      "Etiqueta viajera - Almacén/Cuarentena"
                                    }
                                    llamada={"Todo"}
                                  />*/}
                                </Td>
                                {/*  onClick={() => clicImprimir(x)} */}
                              </Tr>
                            )
                          );
                        })}
                      </Tbody>
                    </Table>
                  </div>
                  {/*<div  className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 " style={{ marginTop: 20 }}>{JSON.stringify(mRecibas)}</div>*/}
                </Row>
              </Fragment>
            )}
          </div>
          <div className="conteiner3">
            {formType === "Incoming Reciba " + formData.numero && (
              <Fragment>
                <div className="">
                  <Row>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <button
                        class="btn-info cbutton floatright"
                        onClick={cancelarRecibaIncoming}
                        title="Regresar">
                        {" "}
                        <IoIcons.IoMdArrowRoundBack />
                        Regresar{" "}
                      </button>
                    </div>
                    <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px scroll">
                      <div className="textaligmentleft">
                        {" "}
                        <h5>Datos generales</h5>
                        {(mRecibas.cliente === "METALSTA" || mRecibas.cliente === "AMPHENOL ADRONICS") && (<h5 className="bcolordb">Identificar con Cono Verde</h5>)}
                      </div>
                      <Table className=" mb-2  ">
                        <Thead class="thead-secondary">
                          <Tr>
                            <Th>ID</Th>
                            <Th>Cliente</Th>
                            <Th className="minwidth80px">
                              Fecha y hora de reciba
                            </Th>
                            <Th>Cantidad Recibida</Th>
                            <Th>Status</Th>
                            <Th> Quien Inspeccionó </Th>
                            <Th> Comentarios de inspección </Th>
                            <Th> PO'S </Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          <Tr>
                            <Td>{formData.numero}</Td>
                            <Td>{formData.cliente}</Td>
                            <Td className="margintopmobil20px">
                              {Moment(formData.fechaDeReciba).format(
                                "DD/MM/YYYY"
                              ) +
                                " " +
                                formData.horaDeReciba}
                            </Td>
                            <Td className="margintopmobil20px">
                              {formData.cantidadRecibida}
                            </Td>
                            <Td className="margintopmobil20px">
                              {formData.status}
                            </Td>
                            <Td className="margintopmobil20px">
                              {formData.quienInspecciono}
                            </Td>
                            <Td className="margintopmobil20px">
                              {formData.comentarios}
                            </Td>
                            <Td className="margintopmobil40px">
                              {formData.po}
                            </Td>
                          </Tr>
                        </Tbody>
                      </Table>
                    </div>
                    <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12  margintop20px mb-2 scroll">
                      <div className="floatleft">
                        <h5>Detalle</h5>
                      </div>
                      <Label className="floatrightleft marginr-1150px">
                        <input
                          type="checkbox"
                          name="VUAP"
                          onChange={(e) => setMDatosInspeccion(e.target.checked)}
                          className="ml-2"
                          checked={mDatosInspeccion}
                        />
                        Mismos datos de inspección {mDatosInspeccion ? "Sí" : "No"}
                      </Label>
                      <Label className="floatrightleft">
                        <input
                          type="checkbox"
                          name="VUAP"
                          onChange={(e) => setMEstatusUbicacion(e.target.checked)}
                          className="ml-2"
                          checked={mEstatusUbicacion}
                        />
                        Mismo estatus y ubicación
                      </Label>
                      <Table className=" mb-2">
                        <Thead class="thead-secondary">
                          <Tr>
                            <Th>#</Th>
                            <Th>
                              {" "}
                              {formData.cliente === "Olson Internacional"
                                ? "Line"
                                : "Packing"}
                            </Th>
                            <Th className="minwidth130px">Número de parte</Th>
                            <Th>Descripción</Th>
                            <Th>Lote</Th>
                            <Th className="minwidth150px">Serial</Th>
                            <Th className="minwidth150px">Serial BTI</Th>
                            <Th>Cantidad</Th>
                            <Th className="minwidth130px">Estatus*</Th>
                            <Th className="minwidth180px">Ubicación*</Th>
                            <Th className="minwidth150px">Locación</Th>
                            <Th>Espacios</Th>
                            <Th>Fecha de ubicación* </Th>
                            <Th className="minwidth100px">
                              Hora de ubicación*{" "}
                            </Th>
                            <Th className="minwidth200px">Quién Inspeccionó</Th>
                            <Th className="minwidth200px">Defecto</Th>
                            <Th className="minwidth300px">Comentarios</Th>
                            <Th className="minwidth150px">Empaque libre de daño</Th>
                            <Th className="minwidth150px">Material correcto/ no mezclado</Th>
                            <Th className="minwidth150px">Material no contaminado con oxido, grasas, material extraño</Th>
                            <Th className="minwidth150px">Material sin defectos obvios (piezas dobladas o golpeadas)</Th>
                            <Th className="minwidth150px">Prueba de solubilidad</Th>
                            <Th className="minwidth150px">Espesor</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {inputList.map((x, i) => {
                            return (
                              x.activo && (
                                <Tr class={i % 2 !== 0 ? "table-active" : ""}>
                                  <Td className="margintopmobil20px">
                                    {i + 1}
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    {x.packing}
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    {x.numerodeParte}
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    {x.descripcion}
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    {x.lote}
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    {x.serial}
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    {x.serialRecibaBTI}
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    {x.cantidadRecibida}
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    <select
                                      name="status"
                                      className=" custom-select"
                                      onChange={(e) =>
                                        setInputUbicaciones(
                                          onChangesUbicacion(e, i, [
                                            ...inputList,
                                          ])
                                        )
                                      }
                                      disabled={!x.cantidadPlaneada ? false : x.cantidadPlaneada > 0 ? true : false}>
                                      <option
                                        value="En reciba"
                                        selected={
                                          x.status === "En reciba"
                                            ? true
                                            : false
                                        }>
                                        {"En reciba"}
                                      </option>
                                      <option
                                        value="Aceptado"
                                        selected={
                                          x.status === "Aceptado" ? true : false
                                        }>
                                        Aceptado
                                      </option>
                                      <option
                                        value="Rechazado"
                                        selected={
                                          x.status === "Rechazado"
                                            ? true
                                            : false
                                        }>
                                        Rechazado
                                      </option>
                                    </select>{" "}
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    <select
                                      name="ubicacion"
                                      className=" custom-select"
                                      onChange={(e) =>
                                        setInputUbicaciones(
                                          onChangesUbicacion(e, i, [
                                            ...inputList,
                                          ])
                                        )
                                      }
                                      disabled={!x.cantidadPlaneada ? false : x.cantidadPlaneada > 0 ? true : false}>
                                      {x.status === "Aceptado" && (
                                        <>
                                          <option
                                            value="Almacén"
                                            selected={
                                              x.ubicacion === "Almacén"
                                                ? true
                                                : false
                                            }>
                                            Almacén
                                          </option>
                                          <option
                                            value="Producción"
                                            selected={
                                              x.ubicacion === "Producción"
                                                ? true
                                                : false
                                            }>
                                            Producción
                                          </option>
                                          <option
                                            value="Proveedor externo"
                                            selected={
                                              x.ubicacion ===
                                                "Proveedor externo"
                                                ? true
                                                : false
                                            }>
                                            Proveedor externo
                                          </option>
                                        </>
                                      )}
                                      {x.status === "En reciba" && (
                                        <>
                                          <option
                                            value="Reciba"
                                            selected={
                                              x.ubicacion === "Reciba"
                                                ? true
                                                : false
                                            }>
                                            Reciba
                                          </option>
                                        </>
                                      )}
                                      {x.status === "Rechazado" && (
                                        <>
                                          <option
                                            value="Cuarentena"
                                            selected={
                                              x.ubicacion === "Cuarentena"
                                                ? true
                                                : false
                                            }>
                                            Cuarentena
                                          </option>
                                        </>
                                      )}
                                    </select>
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    {x.ubicacion === "Almacén" && (
                                      <>
                                        <select
                                          name="locacion"
                                          className=" custom-select"
                                          disabled={!x.cantidadPlaneada ? false : x.cantidadPlaneada > 0 ? true : false}
                                          onChange={(e) =>
                                            setInputList(
                                              handleInputChangeLocacion(e, i, [
                                                ...inputList,
                                              ])
                                            )
                                          }>
                                          {x.locacion !== "" && (
                                            <option
                                              className=""
                                              value={x.locacion}
                                              selected="true">
                                              {x.locacion}{" "}
                                            </option>
                                          )}
                                          <option
                                            className=""
                                            value=""
                                            selected={
                                              x.locacion === "" ? true : false
                                            }>
                                            Elige locación
                                          </option>
                                          {locaciones.map((locacion, i) => (
                                            <>
                                              <option
                                                className=""
                                                value={locacion.locacion}>
                                                {/*selected={x.locacion === locacion.locacion ? true : false}  */}
                                                {locacion.locacion}
                                              </option>
                                            </>
                                          ))}
                                        </select>
                                      </>
                                    )}
                                    {(x.ubicacion === "Cuarentena" ||
                                      x.ubicacion === "Proveedor externo") && (
                                        <>
                                          <Input
                                            name="locacion"
                                            value={x.locacion}
                                            type="text"
                                            disabled={!x.cantidadPlaneada ? false : x.cantidadPlaneada > 0 ? true : false}
                                            onChange={(e) =>
                                              setInputList(
                                                handleInputChangeLocacion(e, i, [
                                                  ...inputList,
                                                ])
                                              )
                                            }
                                          />
                                        </>
                                      )}
                                    {x.ubicacion === "Producción" && (
                                      <>
                                        <select
                                          name="locacion"
                                          className=" custom-select"
                                          disabled={!x.cantidadPlaneada ? false : x.cantidadPlaneada > 0 ? true : false}
                                          onChange={(e) =>
                                            setInputList(
                                              handleInputChangeLocacion(e, i, [
                                                ...inputList,
                                              ])
                                            )
                                          }>
                                          <option value="Carga">Carga</option>
                                          <option value="Pintado">
                                            Pintado
                                          </option>
                                          <option value="Inspección">
                                            Inspección
                                          </option>
                                        </select>
                                      </>
                                    )}
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    {x.ubicacion === "Almacén" &&
                                      x.espacioOcupado > 0 && (
                                        <>
                                          <select
                                            name="espacioOcupado"
                                            className=" custom-select"
                                            disabled={!x.cantidadPlaneada ? false : x.cantidadPlaneada > 0 ? true : false}
                                            onChange={(e) =>
                                              setInputList(
                                                handleInputChangeEspacio(e, i, [
                                                  ...inputList,
                                                ])
                                              )
                                            }>
                                            <option
                                              value={1}
                                              selected={
                                                x.espacioOcupado === 1
                                                  ? true
                                                  : false
                                              }>
                                              1
                                            </option>
                                            {x.espacioOcupado > 1 && (
                                              <option
                                                value={2}
                                                selected={
                                                  x.espacioOcupado === 2
                                                    ? true
                                                    : false
                                                }>
                                                2
                                              </option>
                                            )}
                                            {x.espacioOcupado > 2 && (
                                              <option
                                                value={3}
                                                selected={
                                                  x.espacioOcupado === 3
                                                    ? true
                                                    : false
                                                }>
                                                3
                                              </option>
                                            )}
                                          </select>
                                        </>
                                      )}
                                  </Td>
                                  <Td
                                    className={
                                      Moment(new Date()).format("YYYY-MM-DD") <
                                        Moment(x.fechaDeUbicacion).format(
                                          "YYYY-MM-DD"
                                        ) || x.fechaDeUbicacion === ""
                                        ? "novalido margintopmobil20px"
                                        : "margintopmobil20px"
                                    }>
                                    <Input
                                      name="fechaDeUbicacion"
                                      type="date"
                                      value={x.fechaDeUbicacion}
                                      disabled={!x.cantidadPlaneada ? false : x.cantidadPlaneada > 0 ? true : false}
                                      onChange={(e) =>
                                        setInputUbicaciones(
                                          onChangesFechaUbicacion(e, i, [
                                            ...inputList,
                                          ])
                                        )
                                      }
                                    />
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    <TimeField
                                      name="horaDeUbicacion"
                                      className="w-100 custom-time"
                                      disabled={!x.cantidadPlaneada ? false : x.cantidadPlaneada > 0 ? true : false}
                                      value={x.horaDeUbicacion}
                                      onChange={(e) =>
                                        setInputUbicaciones(
                                          onChangesUbicacion(e, i, [
                                            ...inputList,
                                          ])
                                        )
                                      }
                                    />
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    {" "}
                                    <Input
                                      name="quienInspecciono"
                                      type="text"
                                      disabled={!x.cantidadPlaneada ? false : x.cantidadPlaneada > 0 ? true : false}
                                      value={x.quienInspecciono}
                                      onChange={(e) =>
                                        setInputUbicaciones(
                                          onChangesUbicacion(e, i, [
                                            ...inputList,
                                          ])
                                        )
                                      }
                                    />
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    {" "}
                                    <Input
                                      name="defectoCuarentena"
                                      type="textarea"
                                      disabled={!x.cantidadPlaneada ? false : x.cantidadPlaneada > 0 ? true : false}
                                      rows="1"
                                      value={x.defectoCuarentena}
                                      onChange={(e) =>
                                        setInputUbicaciones(
                                          onChangesUbicacion(e, i, [
                                            ...inputList,
                                          ])
                                        )
                                      }
                                    />{" "}
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    {" "}
                                    <Input
                                      name="comentariosdeinspeccion"
                                      type="textarea"
                                      disabled={!x.cantidadPlaneada ? false : x.cantidadPlaneada > 0 ? true : false}
                                      rows="1"
                                      value={x.comentariosdeinspeccion}
                                      onChange={(e) =>
                                        setInputUbicaciones(
                                          onChangesUbicacion(e, i, [
                                            ...inputList,
                                          ])
                                        )
                                      }
                                    />
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    <select
                                      name="empaqueSinDanos"
                                      className=" custom-select"
                                      onChange={(e) =>
                                        setInputUbicaciones(
                                          onChangesUbicacion(e, i, [
                                            ...inputList,
                                          ])
                                        )
                                      }
                                    >
                                      <option
                                        value=""
                                        selected={
                                          x.empaqueSinDanos === ""
                                            ? true
                                            : false
                                        }>
                                        ---
                                      </option>
                                      <option
                                        value="OK"
                                        selected={
                                          x.empaqueSinDanos === "OK"
                                            ? true
                                            : false
                                        }>
                                        OK
                                      </option>
                                      <option
                                        value="NOK"
                                        selected={
                                          x.empaqueSinDanos === "NOK"
                                            ? true
                                            : false
                                        }>
                                        NOK
                                      </option>
                                      <option
                                        value="N/A"
                                        selected={
                                          x.empaqueSinDanos ===
                                            "N/A"
                                            ? true
                                            : false
                                        }>
                                        N/A
                                      </option>
                                    </select>
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    <select
                                      name="materialCorrecto"
                                      className=" custom-select"
                                      onChange={(e) =>
                                        setInputUbicaciones(
                                          onChangesUbicacion(e, i, [
                                            ...inputList,
                                          ])
                                        )
                                      }
                                    >
                                      <option
                                        value=""
                                        selected={
                                          x.materialCorrecto === ""
                                            ? true
                                            : false
                                        }>
                                        ---
                                      </option>
                                      <option
                                        value="OK"
                                        selected={
                                          x.materialCorrecto === "OK"
                                            ? true
                                            : false
                                        }>
                                        OK
                                      </option>
                                      <option
                                        value="NOK"
                                        selected={
                                          x.materialCorrecto === "NOK"
                                            ? true
                                            : false
                                        }>
                                        NOK
                                      </option>
                                      <option
                                        value="N/A"
                                        selected={
                                          x.materialCorrecto ===
                                            "N/A"
                                            ? true
                                            : false
                                        }>
                                        N/A
                                      </option>
                                    </select>
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    <select
                                      name="materialNContaminado"
                                      className=" custom-select"
                                      onChange={(e) =>
                                        setInputUbicaciones(
                                          onChangesUbicacion(e, i, [
                                            ...inputList,
                                          ])
                                        )
                                      }
                                    >
                                      <option
                                        value=""
                                        selected={
                                          x.materialNContaminado === ""
                                            ? true
                                            : false
                                        }>
                                        ---
                                      </option>
                                      <option
                                        value="OK"
                                        selected={
                                          x.materialNContaminado === "OK"
                                            ? true
                                            : false
                                        }>
                                        OK
                                      </option>
                                      <option
                                        value="NOK"
                                        selected={
                                          x.materialNContaminado === "NOK"
                                            ? true
                                            : false
                                        }>
                                        NOK
                                      </option>
                                      <option
                                        value="N/A"
                                        selected={
                                          x.materialNContaminado ===
                                            "N/A"
                                            ? true
                                            : false
                                        }>
                                        N/A
                                      </option>
                                    </select>
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    <select
                                      name="materialSinDefectosOvios"
                                      className=" custom-select"
                                      onChange={(e) =>
                                        setInputUbicaciones(
                                          onChangesUbicacion(e, i, [
                                            ...inputList,
                                          ])
                                        )
                                      }
                                    >
                                      <option
                                        value=""
                                        selected={
                                          x.materialSinDefectosOvios === ""
                                            ? true
                                            : false
                                        }>
                                        ---
                                      </option>
                                      <option
                                        value="OK"
                                        selected={
                                          x.materialSinDefectosOvios === "OK"
                                            ? true
                                            : false
                                        }>
                                        OK
                                      </option>
                                      <option
                                        value="NOK"
                                        selected={
                                          x.materialSinDefectosOvios === "NOK"
                                            ? true
                                            : false
                                        }>
                                        NOK
                                      </option>
                                      <option
                                        value="N/A"
                                        selected={
                                          x.materialSinDefectosOvios ===
                                            "N/A"
                                            ? true
                                            : false
                                        }>
                                        N/A
                                      </option>
                                    </select>
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    <select
                                      name="pruebaSolubilidad"
                                      className=" custom-select"
                                      onChange={(e) =>
                                        setInputUbicaciones(
                                          onChangesUbicacion(e, i, [
                                            ...inputList,
                                          ])
                                        )
                                      }
                                    >
                                      <option
                                        value=""
                                        selected={
                                          x.pruebaSolubilidad === ""
                                            ? true
                                            : false
                                        }>
                                        ---
                                      </option>
                                      <option
                                        value="OK"
                                        selected={
                                          x.pruebaSolubilidad === "OK"
                                            ? true
                                            : false
                                        }>
                                        OK
                                      </option>
                                      <option
                                        value="NOK"
                                        selected={
                                          x.pruebaSolubilidad === "NOK"
                                            ? true
                                            : false
                                        }>
                                        NOK
                                      </option>
                                      <option
                                        value="N/A"
                                        selected={
                                          x.pruebaSolubilidad ===
                                            "N/A"
                                            ? true
                                            : false
                                        }>
                                        N/A
                                      </option>
                                    </select>
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    <Input
                                      name="espesor"
                                      type="text"

                                      rows="1"
                                      value={x.espesor}
                                      onChange={(e) =>
                                        setInputUbicaciones(
                                          onChangesUbicacion(e, i, [
                                            ...inputList,
                                          ])
                                        )
                                      }
                                    />
                                  </Td>
                                </Tr>
                              )
                            );
                          })}
                        </Tbody>
                      </Table>
                      {/*<div style={{ marginTop: 20 }}>{JSON.stringify(recibaSerialesSinFiltro)}</div>*/}
                      {/*<div style={{ marginTop: 20 }}>{JSON.stringify(inputList)}</div>*/}
                    </div>
                  </Row>
                </div>
                <div>
                  <Button
                    className="floatright"
                    onClick={cancelarRecibaIncoming}
                    color="danger">
                    Cancelar
                  </Button>
                  <Button
                    className="floatright"
                    onClick={() => guardarIncomming(false)}
                    disabled={isDisabled}
                    color="primary">
                    Guardar
                  </Button>
                </div>
              </Fragment>
            )}
          </div>
        </>
      )}
    </>
  );
}

export default Incoming;
